var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Color } from './widgets/color';
import { Enum } from './widgets/enum';
import { Select } from './widgets/select';
const preferredSizes = [12, 14, 16, 20, 24, 28, 32, 36, 48];
const preferredWeight = [{
  value: 'normal',
  label: '普通'
}, {
  value: 'bold',
  label: '加粗'
}, {
  value: 'lighter',
  label: '更细'
}, {
  value: 'bolder',
  label: '更粗'
}, 100, 200, 300, 400, 500, 600, 700, 800, 900];
let FontStyle = class FontStyle extends Vue {
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-stylePanel-wrapFlexLine"
    }, [h(Color, {
      "attrs": {
        "title": "文字颜色",
        "propKey": "color"
      }
    }), h(Select, {
      "attrs": {
        "title": "字号",
        "propKey": "fontSize",
        "searchAndInput": true,
        "options": preferredSizes
      }
    }), h(Select, {
      "attrs": {
        "title": "粗细",
        "propKey": "fontWeight",
        "searchAndInput": true,
        "options": preferredWeight
      }
    }), h(Enum, {
      "attrs": {
        "title": "文字粗细",
        "propKey": "fontWeight",
        "options": this.fontWeightOptions
      }
    }), h(Enum, {
      "attrs": {
        "title": "文字风格",
        "propKey": "fontStyle",
        "options": this.fontStyleOptions
      }
    }), h(Enum, {
      "attrs": {
        "title": "装饰",
        "propKey": "textDecoration",
        "options": this.textDecorationOptions
      }
    })]);
  }
  get fontStyleOptions() {
    const h = this.$createElement;
    return [{
      label: h("span", {
        "class": "ucd-stylePanel-enumBox",
        "style": "font-style: italic"
      }, ["I"]),
      value: 'italic'
    }];
  }
  get fontWeightOptions() {
    const h = this.$createElement;
    return [{
      label: h("span", {
        "attrs": {
          "title": "加粗(Bold)"
        },
        "class": "ucd-stylePanel-enumBox",
        "style": "font-weight: bold"
      }, ["B"]),
      value: 'bold'
    }, {
      label: h("span", {
        "attrs": {
          "title": "加细(Thiner)"
        },
        "class": "ucd-stylePanel-enumBox",
        "style": "font-weight: lighter"
      }, ["T"]),
      value: 'lighter'
    }];
  }
  get textDecorationOptions() {
    const h = this.$createElement;
    return [{
      label: h("div", {
        "attrs": {
          "title": "下划线"
        },
        "class": "ucd-stylePanel-enumBox",
        "style": "text-decoration: underline"
      }, ["U"]),
      value: 'underline'
    }, {
      label: h("div", {
        "attrs": {
          "title": "删除线"
        },
        "class": "ucd-stylePanel-enumBox",
        "style": "text-decoration: line-through"
      }, ["D"]),
      value: 'line-through'
    }, {
      label: h("div", {
        "attrs": {
          "title": "波浪线"
        },
        "class": "ucd-stylePanel-enumBox",
        "style": "text-decoration: wavy underline"
      }, ["X"]),
      value: 'wavy underline'
    }];
  }
};
FontStyle = __decorate([Component({})], FontStyle);
export default FontStyle;
//# sourceMappingURL=FontStyle.js.map
